<template>
  <v-container class="modern-activities-view pb-12">
    <!-- Premium Global Header (Master Pattern) -->
    <v-row class="mb-6 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="44" class="mr-4 shadow-sm border-white-sm">
          <v-icon color="white" small>fas fa-calendar-check</v-icon>
        </v-avatar>
        <div>
          <div class="text-h4 font-weight-black primary--text d-flex align-center lh-1">
            Actividad Comercial
          </div>
          <div class="caption grey--text font-weight-bold uppercase tracking-widest mt-1">Seguimiento y registro de gestiones de venta</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <export-activities 
          :filters="filter" 
          :options="options" 
          :disabled="loading" 
          :search="search"
          class="mr-3"
        />
        <activity-create-update @updated="fetch"/>
      </div>
    </v-row>

    <!-- Bespoke Metric Cards -->
    <!-- <v-row dense class="mb-8">
      <v-col cols="12" sm="4">
        <v-card class="bespoke-mini-card flat-border h-100" flat>
          <div class="metric-accent blue-accent"></div>
          <v-card-text class="pa-4 text-center px-6">
            <div class="metric-label">Total Actividades</div>
            <div class="text-h5 font-weight-black primary--text tracking-tighter">{{ totalItems }}</div>
            <div class="caption grey--text font-weight-bold mt-1 uppercase tracking-tight">Periodo seleccionado</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="bespoke-mini-card flat-border h-100" flat>
          <div class="metric-accent success-accent"></div>
          <v-card-text class="pa-4 text-center px-6">
            <div class="metric-label">Vendedores Activos</div>
            <div class="text-h5 font-weight-black success--text tracking-tighter">{{ activeSellersCount }}</div>
            <div class="caption grey--text font-weight-bold mt-1 uppercase tracking-tight">Gestión del equipo</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="bespoke-mini-card flat-border h-100" flat>
          <div class="metric-accent primary"></div>
          <v-card-text class="pa-4 text-center px-6">
            <div class="metric-label">Hoy</div>
            <div class="text-h5 font-weight-black orange--text tracking-tighter">{{ activitiesToday }}</div>
            <div class="caption grey--text font-weight-bold mt-1 uppercase tracking-tight">Gestiones realizadas</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->

    <!-- Unified Filter Card -->
    <v-card outlined class="modern-card pa-6 mb-8 shadow-sm">
      <v-row dense>
        <v-col cols="12" sm="6" md="2">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Desde</div>
          <v-text-field 
            v-model='filter.created_after' 
            outlined dense hide-details="auto" 
            type="date" 
            class="modern-input" 
            @change="()=>{options.page=1;fetch()}"
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Hasta</div>
          <v-text-field 
            v-model='filter.created_before' 
            outlined dense hide-details="auto" 
            type="date" 
            class="modern-input" 
            @change="()=>{options.page=1;fetch()}"
          />
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Tipo</div>
          <tipo-activity-selection
            v-model='filter.tipo'
            :loading="loading"
            :disabled="loading"
            :filtro="true"
            @change="()=>{options.page=1;fetch()}"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Responsable</div>
          <v-select
            v-model="filter.seller"
            :items="sellers"
            item-text="email"
            item-value="id"
            placeholder="Todos los vendedores"
            outlined dense hide-details="auto"
            clearable
            class="modern-select"
            @change="()=>{options.page=1;fetch()}"
          >
            <template v-slot:selection="{ item }">
              <span class="body-2 font-weight-bold slate-text">{{item.first_name}} {{item.last_name}}</span>
            </template>
            <template v-slot:item="{ item }">
              <div class="d-block py-1">
                <div class="body-2 font-weight-bold slate-text">{{item.first_name}} {{item.last_name}}</div>
                <div class="caption grey--text">{{item.email}}</div>
              </div>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="3">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Búsqueda</div>
          <v-text-field
            v-model="search"
            placeholder="Cliente, contacto..."
            prepend-inner-icon="mdi-magnify"
            @keyup="searchTimeOut"
            :disabled="loading"
            hide-details="auto"
            dense outlined
            class="modern-search-field"
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Main Results Section -->
    <v-card outlined class="modern-card overflow-hidden shadow-sm">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="modern-table"
        @update:options="fetch"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50],
        }"
      >
        <template v-slot:item.date="{ item }">
          <div class="d-flex flex-column">
            <span class="body-2 grey--text text--darken-4 font-weight-bold">
              {{item.date | moment("DD/MM/YYYY")}}
            </span>
            <span class="caption grey--text italic">{{ fromNow(item.date) }}</span>
          </div>
        </template>

        <template v-slot:item.customer_name="{ item }">
          <div class="body-2 font-weight-black primary--text">{{ item.customer_name }}</div>
          <div class="caption grey--text mt-1 d-flex align-center">
            <v-icon x-small class="mr-1" color="grey lighten-1">fas fa-user-tag</v-icon>
            {{ item.contact }}
          </div>
        </template>

        <template v-slot:item.tipo="{ item }">
          <v-chip 
            small 
            label 
            class="font-weight-black text-uppercase tracking-wider"
            :color="getActivityColor(item.tipo)"
            :text-color="getActivityTextColor(item.tipo)"
          >
            {{ item.tipo }}
          </v-chip>
        </template>

        <template v-slot:item.notes="{ item }">
          <v-tooltip bottom max-width="400">
            <template v-slot:activator="{ on, attrs }">
              <div 
                v-bind="attrs"
                v-on="on" 
                class="caption grey--text text--darken-1 text-truncate"
                style="max-width: 250px;"
              >
                {{ item.notes || '—' }}
              </div>
            </template>
            <div class="pa-2 caption">{{ item.notes || 'Sin observaciones' }}</div>
          </v-tooltip>
        </template>

        <template v-slot:item.created_by__first_name="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="24" color="primary lighten-4" class="mr-2 border-white-sm shadow-sm">
              <span class="caption font-weight-black primary--text">
                {{ item.created_by__first_name ? item.created_by__first_name[0] : 'U' }}
              </span>
            </v-avatar>
            <span class="body-2 font-weight-medium">{{ item.created_by__first_name }}</span>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <activity-create-update :item="item" @updated="fetch"/>
          </div>
        </template>

        <!-- Loading / No Data States -->
        <template v-slot:loading>
          <div class="py-10 text-center">
            <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
            <p class="mt-4 grey--text lato-font">Cargando actividades...</p>
          </div>
        </template>

        <template v-slot:no-data>
          <div class="py-10 text-center">
            <v-icon size="64" color="grey lighten-2">mdi-calendar-search</v-icon>
            <p class="mt-4 grey--text lato-font">No se encontraron registros de actividad.</p>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <confirm
      v-if="itemToDelete"
      v-model="showConfirmDelete" 
      :message="`¿Confirma eliminar esta actividad? Esta operación no se puede deshacer.`"
      @ok="deleteItem(itemToDelete)"
      @cancel="()=>{showConfirmDelete=false;itemToDelete=''}"
    />
  </v-container>
</template>

<script>
import { fetchActivities } from '@/api/salesNotes'
import notifications from '@/utils/notifications'
import moment from 'moment'

export default {
  name: 'ActivitiesBitacora',
  components: {
    ActivityCreateUpdate: () => import('@/components/sales/ActivityCreateUpdate'),
    TipoActivitySelection: () => import('@/components/sales/TipoActivitySelection'),
    ExportActivities: () => import('@/components/sales/ExportActivities'),
    Confirm: () => import('@/components/alerts/Confirm'),
  },
  data() {
    return {
      loading: false,
      filter: {
        created_after: '',
        created_before: '',
        tipo: '',
        customer: '',
        seller: '',
      },
      options: {
        itemsPerPage: 20,
        sortBy: ['date'],
        sortDesc: [true]
      },
      totalItems: 0,
      search: '',
      items: [],
      itemToDelete: '',
      showConfirmDelete: false,
      headers: [
        { text: 'Fecha', align: 'start', value: 'date', class: 'modern-header', width: '120px' },
        { text: 'Cliente', align: 'start', value: 'customer_name', class: 'modern-header' },
        { text: 'Actividad', align: 'start', value: 'tipo', class: 'modern-header', width: '150px' },
        { text: 'Contacto', align: 'start', value: 'contact', class: 'modern-header' },
        { text: 'Observaciones', align: 'start', value: 'notes', class: 'modern-header', sortable: false },
        { text: 'Usuario', align: 'start', value: 'created_by__first_name', class: 'modern-header', width: '120px' },
        { text: '', align: 'end', value: 'actions', class: 'modern-header', sortable: false, width: '100px' },
      ],
      sellers: this.$store.getters.getSellers,
    }
  },
  computed: {
    activeSellersCount() {
      // Logic to count sellers who have activities in the results
      const uniqueSellers = new Set(this.items.map(item => item.created_by__id));
      return uniqueSellers.size;
    },
    activitiesToday() {
      const today = moment().format('YYYY-MM-DD');
      return this.items.filter(item => moment(item.date).format('YYYY-MM-DD') === today).length;
    }
  },
  methods: {
    fromNow(date) {
      if (!date) return ''
      return moment(date).fromNow()
    },
    async fetch() {
      this.loading = true
      
      let created_before = ''
      let created_after = '' 
      if (this.filter.created_after) created_after = moment(this.filter.created_after).format('YYYY-MM-DD')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).format('YYYY-MM-DD')
      
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const ordering = sortBy && sortBy.length ? (sortDesc[0] ? '-' + sortBy[0] : sortBy[0]) : '-date'
      
      const query = `ordering=${ordering}&page=${page}&page_size=${itemsPerPage}&search=${this.search}&date_after=${created_after}&date_before=${created_before}&tipo=${this.filter.tipo}&seller=${this.filter.seller || ''}`
      
      try {
        const data = await fetchActivities(query)
        this.totalItems = data.count
        this.items = data.results
      } catch (err) {
        notifications.showError('Error al cargar actividades', err)
      } finally {
        this.loading = false
      }
    },
    searchTimeOut() {  
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.fetch()
      }, 800);
    },
    getActivityColor(tipo) {
      const colors = {
        'Llamada': '#E0F2F1',
        'Correo': '#E3F2FD',
        'Reunión': '#F3E5F5',
        'Visita': '#E8F5E9',
        'Whatsapp': '#DCF8C6'
      }
      return colors[tipo] || '#F5F5F5'
    },
    getActivityTextColor(tipo) {
      const colors = {
        'Llamada': '#00695C',
        'Correo': '#1565C0',
        'Reunión': '#7B1FA2',
        'Visita': '#2E7D32',
        'Whatsapp': '#128C7E'
      }
      return colors[tipo] || '#616161'
    }
  },
  async mounted() {
    await this.fetch()
  },
}
</script>

<style lang="scss" scoped>
.modern-activities-view { background-color: #f0f2f5; min-height: 100vh; font-family: 'Outfit', sans-serif !important; }
.modern-card { border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 12px !important; background: white; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.03) !important; }
.border-white-sm { border: 2px solid white !important; }
.lh-1 { line-height: 1 !important; }

/* Bespoke Mini Cards */
.bespoke-mini-card { position: relative; background: white !important; border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 12px !important; transition: all 0.3s ease; overflow: hidden; }
.metric-accent { position: absolute; top: 0; left: 0; right: 0; height: 3px; }
.blue-accent { background: #35BDC8; }
.success-accent { background: #4caf50; }

.metric-label { font-size: 0.65rem; font-weight: 800; color: #94a3b8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 4px; }
.tracking-tighter { letter-spacing: -1px; }
.tracking-widest { letter-spacing: 1px !important; }

/* Unified Styles for Inputs */
.modern-input, .modern-select {
  ::v-deep .v-input__control {
    .v-input__slot {
      border-radius: 8px !important;
      background-color: #F8FAFC !important;
      border: 1px solid #E2E8F0 !important;
      box-shadow: none !important;
      
      fieldset { border: none; }
    }
  }
}

/* Table Styling */
.modern-table >>> td { height: 72px !important; border-bottom: 1px solid rgba(0,0,0,0.03) !important; }
.modern-table >>> .v-data-table-header { background-color: #f8fbfc !important; }
.modern-table >>> th { text-transform: uppercase; font-size: 0.7rem !important; font-weight: 800 !important; color: #64748b !important; letter-spacing: 1px !important; }

.italic { font-style: italic; }
.gap-1 { gap: 4px; }
</style>
